<div class="uk-section uk-section-primary uk-preserve-color uk-section-small">
  <div class="uk-container uk-container-expand">
    <div class="uk-flex uk-flex-between">
      <div class="uk-flex uk-flex-middle uk-margin-right">
        <label class="uk-form-label uk-margin-small-right" for="report-year">Survey year</label>
        <select id="report-year" class="uk-select uk-form-large uk-form-width-small" [formControl]="yearControl">
          @for (y of selectableYears; track y) {
            <option [value]="y" [disabled]="!availableYears().includes(y)">
              {{ y }}{{ availableYears().includes(y) ? '' : ' (no data)' }}
            </option>
          }
        </select>
      </div>
      <div>
        <button class="uk-button uk-button-primary uk-button-large" [class.uk-disabled]="exporting || loading()"
                (click)="generateReport()">
          Generate Complete Report
          <span class="uk-margin-small-left" [class.uk-hidden]="!exporting" data-uk-spinner="ratio: 0.7"></span>
        </button>
        @if (!loading() && availableYears().length === 0) {
          <p class="uk-text-danger uk-margin-small-top">No survey data could be loaded for any year.</p>
        }
        <p class="uk-text-meta uk-margin-small-top">
          Charts ready: {{ chartsReadyCount }}/{{ chartsCfg.length }} <br>
          Pies ready: {{ pieChartsReadyCount }} / {{ totalPieChartsCount }}
          <br>
        </p>
      </div>
    </div>
  </div>
</div>


<div class="uk-section uk-section-primary uk-preserve-color uk-section-small">
  <div class="uk-container uk-container-expand uk-child-width-1-3" data-uk-grid>
    <div style="max-height: 300px; overflow: auto; scroll-behavior: smooth;">
      <pre>{{ reportData | json }}</pre>
    </div>
  </div>
</div>

<div class="uk-section uk-section-primary uk-preserve-color uk-section-small">
  <div class="uk-container uk-container-expand">
    @for (chart of chartsCfg; track chart; let i = $index) {
      <div>
        @if (chart.chartSeries.length > 0) {
          <h6 class="uk-flex uk-flex-center">{{ chart.title }}</h6>
          @switch (chart.type) {
            @case ('rangeColumns') {
              <bar-columns-chart [series]="chart.chartSeries" [XAxisTitleText]="'per 1000 FTEs'" whitespace="nowrap"
                                 (chartReady)="onChartReady($event, i)">
              </bar-columns-chart>
            }
            @case ('totalInvestmentsRangeColumns') {
              <bar-columns-chart [series]="chart.chartSeries"
                                 [categories]="['>0 to 1 €M', '>1 to 5 €M', '>5 to 10 €M', '>10 to 50 €M', '>50 to 100 €M', '>100 €M']"
                                 (chartReady)="onChartReady($event, i)">
              </bar-columns-chart>
            }
            @case ('stackedBars') {
              <bar-columns-chart [series]="chart.chartSeries" [categories]="categories" [reversedStacks]="false"
                                 [enableLegend]="true" [stacking]="'normal'" [dataLabelsEnabled]="true"
                                 (chartReady)="onChartReady($event, i)">
              </bar-columns-chart>
            }
            @case ('barChart') {
              <bar-columns-chart [series]="chart.chartSeries" [categories]="categories"
                                 [dataLabelsEnabled]="true" (chartReady)="onChartReady($event, i)">
              </bar-columns-chart>
            }
            @case ('totalInvestments') {
              <bar-columns-chart [series]="chart.chartSeries" [categories]="categories"
                                 [dataLabelsEnabled]="true" [YAxisTitleText]="'€K per 1000 FTEs'"
                                 (chartReady)="onChartReady($event, i)">
              </bar-columns-chart>
            }
            @default {
              <app-world-map [series]="chart.chartSeries" (chartReady)="onChartReady($event, i)"></app-world-map>
            }
          }
          <button class="uk-button uk-button-small uk-button-secondary uk-margin-small-top"
                  (click)="downloadSingleChart(i)">
            Download Chart {{ i + 1 }}
          </button>
        }
      </div>
    }
  </div>
</div>

<div class="uk-section uk-section-primary uk-preserve-color uk-section-small">
  <div class="uk-container uk-container-expand uk-child-width-1-2" data-uk-grid>
    @for (chartArray of chartsCfg; track chartArray; let i = $index) {
      @for (chart of chartArray.pieSeries; track chart; let j = $index) {
        <div>
          <h6 class="uk-flex uk-flex-center">{{ chartArray.title }} - {{ j }}</h6>
          <app-report-pie-chart [series]="chart" (chartReady)="onPieChartReady($event, i, j)"></app-report-pie-chart>
        </div>
      }
    }
  </div>
</div>
